export default "__VITE_ASSET__3WrbSJ4Ufgcr8pL7s0kWpg__"